/** Route guards. `Protected` needs a session; `SuperAdminOnly` /
 * `TenantAdminOnly` additionally need the role — others bounce to the
 * dashboard (never a dead end). */
import { Navigate, Outlet } from "react-router-dom";
import { useAuth } from "../../auth/AuthContext";
import { Spinner } from "../ui";

export function Protected() {
  const { user, loading } = useAuth();
  if (loading) {
    return (
      <div className="grid min-h-screen place-items-center">
        <Spinner size={32} />
      </div>
    );
  }
  if (!user) return <Navigate to="/login" replace />;
  return <Outlet />;
}

/** Holds un-onboarded self-serve learners at the wizard: a solo learner who
 *  hasn't completed onboarding is bounced to /onboarding before any app page.
 *  Gated on `is_self_serve` so INVITED staff — who are also `onboarded ===
 *  false` — are never dragged into the learner questionnaire. */
export function OnboardingGate() {
  const { user } = useAuth();
  if (user && user.is_self_serve && !user.onboarded) {
    return <Navigate to="/onboarding" replace />;
  }
  return <Outlet />;
}

export function SuperAdminOnly() {
  const { isSuperAdmin } = useAuth();
  if (!isSuperAdmin) return <Navigate to="/dashboard" replace />;
  return <Outlet />;
}

export function TenantAdminOnly() {
  const { isTenantAdmin } = useAuth();
  if (!isTenantAdmin) return <Navigate to="/dashboard" replace />;
  return <Outlet />;
}
